import React from 'react'
import LGVideo from '../../../../assets/videos/LG_Video.mp4'

const LGVideoDisplay = ({ handleBackToGallery }) => {
  return (
    <div className="notification-wrapper">
      <div className="lg-video">
        <video width="100%" height="auto" autoPlay controls loop>
          <source src={LGVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <button className="back-to-gallery-btn" onClick={handleBackToGallery}>
          Back to Gallery
        </button>
      </div>
    </div>
  )
}

export default LGVideoDisplay
